<!--
 * @Description: 试卷审批 详情
 * @Author: PF
 * @Date: 2024-02-04 10:58:57
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:26:24
-->
<template>
  <div>
    <el-dialog class="wp80 hp90" :model-value="openShenPi" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">审批详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openShenPi', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container>
        <el-header class="pl0 pr0 pb10" style="max-height:50%">
          <ul class="title">
            <li><span><span style="color: #000;">考试计划：</span>{{shiJuan.ksjhmc}}</span></li>
            <li><span><span style="color: #000;">科目：</span>{{shiJuan.kskmmc}}</span></li>
            <li><span v-for="(item, index) in sjlxData.list" :key="index" style="color: #000;">
              <span v-if="shiJuan.sjlb === item.value">
                {{ item.name }}
              </span>
            </span></li>
            <li><span><span style="color: #000;">总分：</span>{{zongFenShu}}</span></li>
          </ul>
          <ul class="title">
            <li><span><span style="color: #000;">审核状态：</span><span v-if="shiJuan.shzt==9">同意</span><span v-if="shiJuan.shzt==10">拒绝</span></span></li>
            <li><span><span style="color: #000;">审核时间：</span>{{shiJuan.shsj}}</span></li>
            <li><span><span style="color: #000;">审核意见：</span>{{shiJuan.shyj}}</span></li>
          </ul>
          <div v-if="sjlxData.shiJuanSuiJiShiTi === shiJuan.sjlb" style="max-height: calc(100% - 39px);">
            <el-row v-for="(item, index) in listKeChengJxdy" :key="index" style="display: flex;justify-content: space-between;align-items: baseline;">
              <el-col :span="6">
                <div>课程：{{ item.kcmc }}</div>
              </el-col>
              <el-col :span="18">
                <div>教学单元：<span v-for="(val, ind) in item.listJxdyfw" :key="ind"><span v-if="ind>0">、</span><span>{{ val }}</span></span></div>
              </el-col>
            </el-row>
          </div>
        </el-header>
        <el-main class="pl0 pr0 pb0">
          <zhidingshijuan v-if="sjlxData.zhiDingShiJuan === shiJuan.sjlb" :row="listShiTi"/>
          <suijishijuan v-if="sjlxData.shiJuanSuiJiShiTi === shiJuan.sjlb" :row="listShiTiSheZhi"/>
        </el-main>
      </el-container>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { actionPost, loadSelect, closeWindow } from '@/api/common.js'
import { getTiXing } from '@/utils/zidianmeiju'
import { warningPrompt } from '@/utils/promptInfo.js'
import zhidingshijuan from './zhidingshijuan/list'
import suijishijuan from './suijishijuan/list'

const props = defineProps({
  openShenPi: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openShenPi'])

const row = ref()
const shiJuan = ref({})
const listShiTi = ref([])
const listShiTiSheZhi = ref([])
const listKeChengJxdy = ref([])
const zongFenShu = ref(0)

const zytxData = ref({ list: [] }) // 题型
const sjlxData = ref({ list: [] }) // 试卷类型

// 计算总分
const fenZhiChange = () => {
  let fzs = []
  if (sjlxData.value.zhiDingShiJuan === shiJuan.value.sjlb) {
    fzs = listShiTi.value.map((item) => item.txmrfs)
  } else {
    fzs = listShiTiSheZhi.value.map((item) => item.mtfs)
  }

  let sum = 0
  fzs.forEach((element) => {
    sum += element
  })
  zongFenShu.value = sum.toFixed(1)
}
watch(
  () => props.openShenPi,
  () => {
    if (props.openShenPi) {
      zytxData.value = getTiXing()
      row.value = props.row
      loadSelect({ url: '/api/v2/jiaowu/kaowukaoshijihua/shijuanleibie', data: sjlxData })
      actionPost({
        url: '/api/v2/jiaowu/kaowukaoshijihua/shijuanzujuanshenpidaibanxiangqing',
        data: { dbsxid: props.row.id }
      }).then((res) => {
        if (res.code === 200) {
          shiJuan.value = res.data.shiJuan
          listShiTi.value = res.data.listShiTi
          listKeChengJxdy.value = res.data.listKeChengJxdy
          listShiTiSheZhi.value = res.data.listShiTiSheZhi
          fenZhiChange()
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)

</script>
<style lang="less" scoped>
.title {
  color: #73767a;
  display: flex;
  font-size: 1.3em;
  margin-bottom: 10px;
  li {
    margin-right: 15px;
  }
}
</style>
